"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _usePageGroups = _interopRequireDefault(require("./hooks/usePageGroups"));

var _PageGroupList = _interopRequireDefault(require("./PageGroupList"));

var FieldOrderPanel = function FieldOrderPanel(_ref) {
  var questionSet = _ref.questionSet;
  var pageGroups = (0, _usePageGroups["default"])(questionSet);
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      "data-testid": "field-order-panel"
    }, Object.values(pageGroups).map(function (pageGroup) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          key: pageGroup.pageNumber,
          style: {
            marginBottom: '20px'
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_reactBootstrap.Container, {
          style: {
            fontSize: '16px',
            marginBottom: '0px',
            borderBottom: '3px solid grey'
          }
        }, "PAGE " + pageGroup.pageNumber),
        /*#__PURE__*/
        _react["default"].createElement(_PageGroupList["default"], {
          questionList: pageGroup.questions
        }))
      );
    }))
  );
};

FieldOrderPanel.defaultProps = {
  questionSet: []
};
FieldOrderPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  questionSet: _propTypes["default"].arrayOf(_propTypes["default"].any)
} : {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    questionSet: state.questionSet.questions.sort(function (a, b) {
      return a.position - b.position;
    })
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(FieldOrderPanel);